/*
    Add here your own custom javascript ​​‍‌‍‍​‍​​⁠‌​​​‍​​​‌‍​​​​‍​‌​​‍​‌‌​‍​‌​‌‍​​‌‌‍​‌‌​‍​‌​‌‍​​‌​‍​​​​‍​‌​‌‍​​​​﻿‌‍‍​​‍‌‍​​
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})


/* Compact mobile header: toggled by an IntersectionObserver sentinel at the
   very top of the page, so there is no scroll listener on the main thread. */
;(function () {
    if (!('IntersectionObserver' in window)) { return; }
    var start = function () {
        var body = document.body;
        var ann = document.querySelector('.announcement-bar');
        var annWrap = ann && ann.closest('.shopify-section');
        var nav = document.querySelector('#navbar-mobile');
        if (!nav) { return; }

        /* Publish both heights so the two bars can travel as one block. */
        var measure = function () {
            var a = annWrap ? annWrap.offsetHeight : 0;
            body.style.setProperty('--ann-h', a + 'px');
            body.style.setProperty('--nav-h', nav.offsetHeight + 'px');
        };
        measure();
        window.addEventListener('resize', measure, { passive: true });

        var sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
        body.insertBefore(sentinel, body.firstChild);

        new IntersectionObserver(function (entries) {
            var scrolled = !entries[0].isIntersecting;
            body.classList.toggle('nav-compact', scrolled);
            if (!scrolled) {
                body.classList.remove('nav-hidden');
                measure();
            }
        }, { threshold: 0 }).observe(sentinel);

        /* Hide on the way down, bring the compact menu back on the way up.
           Passive listener, one frame at a time, so it does not block input. */
        var lastY = window.pageYOffset;
        var ticking = false;
        window.addEventListener('scroll', function () {
            if (ticking) { return; }
            ticking = true;
            window.requestAnimationFrame(function () {
                var y = window.pageYOffset;
                var delta = y - lastY;
                if (Math.abs(delta) > 6) {
                    if (delta > 0 && y > 120) {
                        if (!body.classList.contains('nav-hidden')) {
                            measure();
                            body.classList.add('nav-hidden');
                        }
                    } else if (delta < 0) {
                        body.classList.remove('nav-hidden');
                    }
                    lastY = y;
                }
                ticking = false;
            });
        }, { passive: true });
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
